import { NavLink } from "react-router-dom";

export function Sidebar() {
  // Main menu without Settings (to be put at the bottom)
  const menu = [
    { name: "Dashboard", icon: "📊", path: "/" },
    { name: "Checklist", icon: "📋", path: "/checklist" },
    { name: "Leave", icon: "🏖️", path: "/leave" },
    { name: "Attendance", icon: "⏱️", path: "/attendance" },
    { name: "Parking", icon: "🚗", path: "/parking" },
    { name: "Recruit", icon: "🧑‍💼", path: "/recruit" },
    { name: "Messages", icon: "💬", path: "/messages" },
    { name: "Help", icon: "❓", path: "/help" },
    { name: "Users", icon: "👥", path: "/users" }
  ];

  return (
    <aside className="w-64 bg-white border-r shadow-sm h-screen p-5 flex flex-col">
      <div className="text-2xl font-bold text-green-600 mb-6">LessSpace</div>
      <ul className="space-y-3 flex-1">
        {menu.map((item) => (
          <li key={item.name}>
            <NavLink
              to={item.path}
              className={({ isActive }) =>
                `flex items-center gap-3 p-3 rounded-xl font-medium cursor-pointer
                ${isActive ? "bg-blue-100 text-blue-600" : "text-gray-700 hover:bg-blue-50"}`
              }
            >
              <span>{item.icon}</span>
              {item.name}
            </NavLink>
          </li>
        ))}
      </ul>
      <ul className="mt-auto">
        <li>
          <NavLink
            to="/settings"
            className={({ isActive }) =>
              `flex items-center gap-3 p-3 rounded-xl font-medium cursor-pointer
              ${isActive ? "bg-blue-100 text-blue-600" : "text-gray-700 hover:bg-blue-50"}`
            }
          >
            <span>⚙️</span>
            Settings
          </NavLink>
        </li>
      </ul>
    </aside>
  );
}
